<script setup lang="ts"></script>

<template>
  <header
    class="page-header bg-background-secondary border-stroke-panel grid h-11 w-full shrink-0 grow-0 grid-cols-[1fr_auto_1fr] items-center justify-between gap-2 px-4 md:h-[54px] md:border-b md:px-6"
  >
    <div class="flex justify-start"><slot name="left"></slot></div>
    <h1 class="truncate font-semibold text-white" v-if="$slots.title">
      <slot name="title"></slot>
    </h1>
    <div class="flex justify-end"><slot name="right"></slot></div>
  </header>
</template>

<style lang="scss" scoped>
.page-header {
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.18);
}
</style>
